const axios = require('axios').default;

function PostFreeEffectForSubscription(effect, name, text) {
    return axios.post('/api/subscription/effect', JSON.stringify({
        'effect': effect,
        'name': name,
        'text': text,
    }), {
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

function PostFreeEffect(effect, name, text, captcha) {
  return axios.post('/api/free-effect', JSON.stringify({
    'effect': effect,
    'name': name,
    'text': text,
    'captcha': captcha,
  }), {
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

function PostDonationEffect(effect, name, text, amount, channelCurrency, paymentCurrency) {
    return axios.post('/api/donation/effect', JSON.stringify({
      'effect': {
        'effect': effect,
        'name': name,
        'text': text,
        'amount': amount,
        'currency': channelCurrency,
      },
      'payment_currency': paymentCurrency,
    }), {
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

function GetCryptoPaymentStatus(addressUUID) {
    return axios.get(`/api/cryptopaymentstatus?uuid=${addressUUID}`);
}

function GetSubscription() {
    return axios.get('/api/subscription');
}

function Subscribe(level_id, months = 1) {
    return axios.post(`/api/subscription/subscribe`, { level_id, months });
}

function CheckoutSubscribe(amount) {
    return axios.post('/api/checkout/subscribe', { amount });
}

function Unsubscribe() {
    return axios.post(`/api/subscription/unsubscribe`);
}

function PaySubscription(months = 1) {
    return axios.post(`/api/subscription/pay`, { months });
}

function CancelPendingSubscription() {
  return axios.post('/api/subscription/cancel-pending');
}

function SubscribeCrypto(level_id, months = 1, payment_currency = 'BTC') {
  return axios.post('/api/subscription/cryptoaddress', {
    level_id,
    months,
    payment_currency,
  });
}

function GetPublicSponsorName() {
  return axios.get('/api/subscription/public-name');
}

function SetPublicSponsorName(name) {
  return axios.post('/api/subscription/public-name', JSON.stringify({public_name: name || ''}), {
    headers: {'Content-Type': 'application/json'},
  });
}

function CreateGiftSubscriptionPurchase(level_id, months = 1, quantity = 1, method = 'card', payment_currency = null) {
  return axios.post('/api/subscription/gift/purchase', {
    level_id,
    months,
    quantity,
    method,
    payment_currency,
  });
}

function GetGiftSubscriptionPurchase(purchase_id) {
  if (!purchase_id) {
    return axios.get('/api/subscription/gift/purchase');
  }
  return axios.get(`/api/subscription/gift/purchase?purchase_id=${encodeURIComponent(purchase_id)}`);
}

function RedeemGiftSubscription(token) {
  return axios.post('/api/subscription/gift/redeem', { token });
}

function GetGiftSubscriptionRedeemPreview(token) {
  return axios.get(`/api/subscription/gift/redeem?token=${encodeURIComponent(token)}`);
}

function GetEffectGenerationSession(sessionUID) {
    return axios.get(`/api/generation/sessionstatus?uuid=${sessionUID}`);
}

function GenerateEffect(generationRequest) {
    return axios.post('/api/generation/generate', JSON.stringify(generationRequest), {
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

function PostGeneratedEffect(attempt_uuid, session_uuid, name, text) {
  const req = {
    attempt_uuid: attempt_uuid,
    session_uuid: session_uuid,
    name: name || undefined,
    text: text || undefined,
  };
  return axios.post('/api/generation/post-effect', JSON.stringify(req), {
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

// Wall posts API (placeholders; backend endpoints may be added later)
function GetWallPosts(cursor = null) {
  const url = cursor ? `/api/wall/posts?cursor=${encodeURIComponent(cursor)}` : '/api/wall/posts';
  return axios.get(url);
}

function GetWallPost(id) {
  return axios.get(`/api/wall/posts/${id}`);
}


export {
    PostFreeEffectForSubscription,
    PostFreeEffect,
    PostDonationEffect,
    GetCryptoPaymentStatus,
    GetSubscription,
    Subscribe,
    CheckoutSubscribe,
    Unsubscribe,
    PaySubscription,
    GetPublicSponsorName,
    SetPublicSponsorName,
    CreateGiftSubscriptionPurchase,
    GetGiftSubscriptionPurchase,
    GetGiftSubscriptionRedeemPreview,
    RedeemGiftSubscription,
    GetEffectGenerationSession,
    GenerateEffect,
    PostGeneratedEffect,
    GetWallPosts,
    GetWallPost,
    SubscribeCrypto,
    CancelPendingSubscription,
}
